import { atom } from "jotai";

export const currentUserAtom = atom({});
export const currentProfileAtom = atom(null);
export const currentRoleAtom = atom(null);
export const currentRoleSettingAtom = atom(null);
export const currentBankChannelAtom = atom({})
